import { render, staticRenderFns } from "./StudentLoginRegister.vue?vue&type=template&id=4c6034aa&scoped=true&"
import script from "./StudentLoginRegister.vue?vue&type=script&lang=js&"
export * from "./StudentLoginRegister.vue?vue&type=script&lang=js&"
import style0 from "./StudentLoginRegister.vue?vue&type=style&index=0&id=4c6034aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6034aa",
  null
  
)

export default component.exports